import { getFastApiBaseUrl } from "../const/env";

// Frontend calls FastAPI directly in all environments.
export const API_BASE_URL = getFastApiBaseUrl();
